import ENV from "../env";
import {getCookie} from "./util";

const Config = {
  wsUrl: ENV.links.wsUrl ? ENV.links.wsUrl : "https://www.yettel.rs/webshop/",
  mojTelenorUrl: ENV.links.mojTelenorUrl ? ENV.links.mojTelenorUrl : "https://www.yettel.rs/yettel/",
  ysdUrl: ENV.links.ysdUrl ? ENV.links.ysdUrl : "https://shopping.yettel.rs/",
  yPayUrl: ENV.links.yPayUrl ? ENV.links.yPayUrl : "https://www.yettel.rs/placanja/",
  tnAccountSettingUrl: ENV.links.tnAccountSettingUrl ? ENV.links.tnAccountSettingUrl : "https://www.yettel.rs/nalog/",
  tnAccountLogoutUrl: ENV.links.tnAccountLogoutUrl ? ENV.links.tnAccountLogoutUrl : "https://www.yettel.rs/webshop/session-logout/",
  cartOverviewUrl: ENV.links.cartOverviewUrl ? ENV.links.cartOverviewUrl : "https://www.yettel.rs/webshop/sr/sr/Privatni-korisnici/Kupovina/",
  businessPortalUrl: ENV.links.businessPortalUrl ? ENV.links.businessPortalUrl : "https://www.yettel.rs/biznisportal/",
  hipernetUrl: ENV.links.hipernetUrl ? ENV.links.hipernetUrl : "https://ytl.rs/hnapp",
  yettelBankUrl: ENV.links.yettelBankUrl ? ENV.links.yettelBankUrl : "https://www.yettelbank.rs/"
}

const getCommonSubItems = (isLoggedIn) => {
  return [
    {
      id: 2,
      title: 'Yettel app',
      url: Config.mojTelenorUrl,
      redirectTo: Config.mojTelenorUrl,
      img: {},
      items: []
    },
    {
      id: 3,
      title: 'Yettel TV',
      url: Config.hipernetUrl,
      redirectTo: Config.hipernetUrl,
      img: {},
      items: []
    },
    {
      id: 1,
      title: isLoggedIn ? 'Webshop' : 'Login',
      url: Config.wsUrl,
      redirectTo: Config.wsUrl,
      img: {},
      items: []
    },
  ];
}

export const getLoginInfo = (userInput, labels) => {
  const user = userInput ? userInput : {
    isLoggedIn: false,
    firstName: '',
    lastName: '',
    userName: '',
    numberOfOrderItems: getCookie('ssb_order') ? 1 : 0
  };

  let items = [];
  if (user.isLoggedIn) {
    items = getCommonSubItems(true).concat([
      {
        id: 3,
        img: {},
        items: [],
        url: Config.tnAccountSettingUrl,
        redirectTo: Config.tnAccountSettingUrl,
        title: labels.tnAccountSettings
      },
      {
        id: 4,
        img: {},
        items: [],
        url: Config.tnAccountLogoutUrl,
        redirectTo: Config.tnAccountLogoutUrl,
        title: labels.logout
      }
    ])

    return items;
  }
  items = getCommonSubItems(false)

  return items;
}

export const getYettelMenuItems = () => {
  return [
    {
      id: 1,
      title: 'Webshop',
      url: Config.wsUrl,
      redirectTo: Config.wsUrl,
      img: "shop",
      items: []
    },
    {
      id: 2,
      title: 'Y. Shopping',
      url: Config.ysdUrl,
      redirectTo: Config.ysdUrl,
      img: "ysd",
      items: []
    },
    {
      id: 3,
      title: 'Yettel portal',
      url: Config.mojTelenorUrl,
      redirectTo: Config.mojTelenorUrl,
      img: "portal",
      items: []
    },
    {
      id: 4,
      title: 'Y. Pay',
      url: Config.yPayUrl,
      redirectTo: Config.yPayUrl,
      img: "ypay",
      items: []
    },
    {
      id: 5,
      title: 'Yettel TV',
      url: Config.hipernetUrl,
      redirectTo: Config.hipernetUrl,
      img: "hipernet",
      items: []
    },
    {
      id: 5,
      title: 'Yettel Bank',
      url: Config.yettelBankUrl,
      redirectTo: Config.yettelBankUrl,
      img: "ybank",
      items: []
    },
  ]
}

export const getProfileMenuItems = () => {
  return {
    "id": 1,
    "title": "Dobrodošli",
    "url": "Dobrodošli",
    "cssClass": "",
    "img": {
      "title": "no-profile-photo"
    },
    "items": [
      {
        "id": 3,
        "img": {},
        "items": [],
        "url": "https://www.yettel.rs/nalog",
        "redirectTo": "https://www.yettel.rs/nalog",
        "title": "Podesi nalog"
      },
      {
        "id": 4,
        "img": {},
        "items": [],
        "url": "",
        "redirectTo": "",
        "title": "Odjavi se"
      }
    ]
  }
}



